// Set the key-value pairs for the different languages you want to support.
export default {

    mediaSelector: {
        photosPermission: 'Without photos access no own workflows with images can be created.',
        cameraPermission: 'Without camera access no own workflows with photos can be created.'
    },

}